import React from "react";
import { useRouteMatch } from "react-router-dom"; // or keep { match } if passed from App.js route
import CustomNavbar from "../components/CustomNavbar";
import DesignBanner from "../components/Banner/DesignBanner";
import Service from "../components/Service/Service";
import Subscribe from "../components/Subscribe";
import Footer from "../components/Footer/Footer";
import FooterData from "../components/Footer/FooterData";
import ServiceData from "../components/Service/ServiceData";
import HomeProcess from "./HomeProcess";
import { Helmet } from "react-helmet";

// 1. Define location metadata mapping object centrally
const locationMetaMap = {
    "/Acacia-Ridge": {
        title: "Cash For Cars in Acacia Ridge - Junk Car Removal Acacia Ridge",
        description: "We have the means to pay the highest cash for cars Acacia Ridge. Get Top Junk Car Removal Acacia Ridge",
        keywords: "Cash For Cars in Acacia Ridge, Junk Car Removal Acacia Ridge",
    },
    "/Brisbane": {
        title: "Cash for Cars in Brisbane - Junk Car Removal Brisbane",
        description: "Get cash for cars Brisbane faster than ever. We have Junk Car Removal in Brisbane",
        keywords: "Cash for Cars in Brisbane, Junk Car Removal Brisbane",
    },
    "/Beenleigh": {
        title: "Cash for Cars in Beenleigh - Junk Car Removal Beenleigh",
        description: "Our Cash For Cars Beenleigh service will give you instant cash for Junk Car Removal Beenleigh",
        keywords: "Cash for Cars in Beenleigh",
    },
    "/Coopers-Plains": {
        title: "Cash for Cars in Coopers Plains - Junk Car Removal Coopers Plains",
        description: "Cash for Cars in Coopers Plains services Junk Car Removal with car recycling.",
        keywords: "Cash for Cars in Coopers Plains",
    },
    "/Gold-Coast": {
        title: "Cash for Cars in Gold Coast - Junk Car Removal in Gold Coast",
        description: "Cash for Cars in Gold Coast is all that you need. Top choice for auto selling cars and buying parts in Gold Coast.",
        keywords: "Cash for Cars in Gold Coast",
    },
    "/Ipswich": {
        title: "Cash for Cars in Ipswich - Junk Car Removal Ipswich",
        description: "Looking to Cash for Cars in Ipswich, Junk Car Removal Ipswich and pay top prices for your old scrap vehicle.",
        keywords: "Cash for Cars in Ipswich",
    },
    "/Rocklea": {
        title: "Cash for Cars in Rocklea - Junk Car Removal Rocklea",
        description: "Cash for Cars in Rocklea. We provide you the great and easy way to turn your scrap car into cash. Junk Car Removal Rocklea",
        keywords: "Cash for Cars in Rocklea",
    },
    "/Sunnybank": {
        title: "Cash for Cars in Sunnybank - Junk Car Removal Sunnybank",
        description: "We are a Cash for Cars in Sunnybank service provider that accepts and removes old and junk cars.",
        keywords: "Cash for Cars in Sunnybank",
    },
    "/Toowoomba": {
        title: "Cash for Cars in Toowoomba - Junk Car Removal Toowoomba",
        description: "Cash for Cars in Toowoomba. Efficient, hassle-free truck and scrap car removal. Professional and Prompt Service.",
        keywords: "Cash for Cars in Toowoomba",
    },
    "/Underwood": {
        title: "Cash for Cars in Underwood - Junk Car Removal Underwood",
        description: "Unwanted Car Buyer in Underwood. Efficient, hassle-free truck and scrap car removal. Professional and Prompt Service.",
        keywords: "Cash for Cars in Underwood, Junk Car Removal Underwood",
    },
    "/Woodridge": {
        title: "Cash for Cars in Woodridge - Junk Car Removal Woodridge",
        description: "Unwanted Car Buyer in Woodridge. Efficient, hassle-free truck and scrap car removal. Professional and Prompt Service.",
        keywords: "Cash for Cars in Woodridge",
    },
};

export const HomeAcacia = ({ match }) => {
    // Fallback gracefully if match or path isn't found
    const currentPath = match ? match.path : "";
    const meta = locationMetaMap[currentPath] || {
        title: "Cash For Cars & Junk Car Removal Queensland",
        description: "Top cash for cars and professional junk car removal services.",
        keywords: "Cash For Cars, Junk Car Removal",
    };

    const canonicalUrl = `https://a1autorecycler.com.au${currentPath}`;

    return (
        <div className="body_wrapper">
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <meta name="keywords" content={meta.keywords} />
                <link rel="canonical" href={canonicalUrl} />
            </Helmet>
            <CustomNavbar cClass="custom_container p0" hbtnClass="new_btn" />
            <DesignBanner />
            <HomeProcess />
            <Service ServiceData={ServiceData} />
            <Subscribe FooterData={FooterData} />
            <Footer FooterData={FooterData} />
        </div>
    );
};